import React from "react";
import styles from "./ViewAllButton.module.scss";

interface ViewAllButtonProps {
  onClick: () => void;
  label?: string;
}

/** Small pill link shown on the right of a widget header to open its "view all" modal. */
export default function ViewAllButton({ onClick, label = "View All" }: ViewAllButtonProps) {
  return (
    // ho-no-print: this control shouldn't appear in the exported PDF
    <button type="button" className={`${styles.btn} ho-no-print`} onClick={onClick}>
      {label}
      <svg
        width="13"
        height="13"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M9 6l6 6-6 6" />
      </svg>
    </button>
  );
}
